import { PromptType } from './enums';

const CIRCLE_PATH =
  'M512 210.827c166.333 0 301.173 134.84 301.173 301.173s-134.84 301.173-301.173 301.173c-166.333 0-301.173-134.84-301.173-301.173s134.84-301.173 301.173-301.173z';

const PLUS_PATH =
  'M512.094 646.123c-9.813 0-17.335-2.615-22.571-7.851-5.231-5.559-7.851-13.248-7.851-23.061v-65.749h-64.275c-9.487 0-16.847-2.453-22.080-7.36-4.907-4.907-7.36-12.105-7.36-21.589s2.453-16.683 7.36-21.589c5.233-4.907 12.593-7.36 22.080-7.36h64.275v-63.296c0-9.813 2.62-17.337 7.851-22.571 5.235-5.234 12.924-7.851 23.061-7.851 9.813 0 17.173 2.617 22.080 7.851 5.235 5.234 7.851 12.757 7.851 22.571v63.296h64.277c9.489 0 16.683 2.453 21.589 7.36 5.235 4.907 7.851 12.105 7.851 21.589s-2.615 16.683-7.851 21.589c-4.907 4.907-12.1 7.36-21.589 7.36h-64.277v65.749c0 9.813-2.615 17.502-7.851 23.061-4.907 5.235-12.429 7.851-22.571 7.851z';

const MINUS_PATH =
  'M420.245 540.224c-7.197 0-13.248-2.291-18.155-6.869s-7.36-10.466-7.36-17.664c0-7.198 2.453-13.248 7.36-18.155 4.907-4.578 10.958-6.869 18.155-6.869h184c7.198 0 13.086 2.291 17.664 6.869 4.907 4.907 7.36 10.957 7.36 18.155s-2.453 13.086-7.36 17.664c-4.578 4.578-10.466 6.869-17.664 6.869h-184z';

const POSITIVE_FILL = 'rgb(39,72,110)';
const NEGATIVE_FILL = 'rgb(198,43,43)';

const ICON_SIZE = 32;
const STROKE_COLOR = 'rgb(255,255,255)';
const STROKE_WIDTH = 80.32;

const buildSvgDataUrl = (fillColor: string, symbolPath: string): string => {
  const svg = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      width="${ICON_SIZE}"
      height="${ICON_SIZE}"
    >
      <path d="${CIRCLE_PATH}" fill="${fillColor}" />
      <path
        d="${CIRCLE_PATH}"
        fill="none"
        stroke="${STROKE_COLOR}"
        stroke-width="${STROKE_WIDTH}"
      />
      <path d="${symbolPath}" fill="${STROKE_COLOR}" />
    </svg>
  `;

  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

const POSITIVE_PROMPT_SVG = buildSvgDataUrl(POSITIVE_FILL, PLUS_PATH);

const NEGATIVE_PROMPT_SVG = buildSvgDataUrl(NEGATIVE_FILL, MINUS_PATH);

export const getPromptSvg = (promptType: PromptType): string =>
  promptType === PromptType.Positive
    ? POSITIVE_PROMPT_SVG
    : NEGATIVE_PROMPT_SVG;
